"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CollectionsTemplate = /** @class */ (function (_super) {
    __extends(CollectionsTemplate, _super);
    function CollectionsTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionsTemplate.prototype.componentDidMount = function () {
        window.location.href = "/collections/all";
    };
    CollectionsTemplate.prototype.render = function () {
        var collections = this.props.data.collections;
        return React.createElement("div", null);
    };
    return CollectionsTemplate;
}(React.Component));
exports.CollectionsTemplate = CollectionsTemplate;
